module.exports = function getResource(label, vars = []) {
    let resources = {
        selectBrand: 'Select your current foundation brand'
    };

    return resources[label];
};
